import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import SelectOption from './SelectOption';
import { Button } from '../ui/Button';

interface Options {
  label: string;
  value: string;
}

interface SearchBarProps {
  searchTitle?: string;
  options?: Options[];
}

const SearchBar: React.FC<SearchBarProps> = (props: SearchBarProps) => {
  // will come from different place
  const searchFilters: Options[] = [
    { label: 'Aankoopmakelaar', value: 'aankoopmakelaar' },
    { label: 'Bankmedewerker', value: 'bankzaken' },
    { label: 'Belastingadviseur', value: 'belasting' },
    { label: 'Duurzaam wonen adviseur', value: 'duurzaamwonen' },
    { label: 'Financieel planner', value: 'financieleplanning' },
    { label: 'Hypotheekadviseur', value: 'hypotheek' },
    { label: 'Kredietadviseur', value: 'lenen' },
    { label: 'Notaris', value: 'notariaat' },
    { label: 'Pensioenadviseur', value: 'pensioen' },
    { label: 'Scheidingsadviseur', value: 'scheiding' },
    { label: 'Taxateur', value: 'taxatie' },
    { label: 'Verkoopmakelaar', value: 'verkoopmakelaar' },
    { label: 'Vermogensadviseur', value: 'vermogen' },
    { label: 'Verzekeringsadviseur', value: 'verzekering' },
  ];
  const [postalCode, setPostalCode] = useState('');
  const [dropDownValue, setDropDownValue] = useState(searchFilters[5]?.value);

  const handleSelectOfAf = (selectedValue: string): void => {
    setDropDownValue(selectedValue);
  };

  const handleSearch = (event: React.FormEvent): void => {
    event.preventDefault();

    // Build the URL with the geoloaction parametr
    let redirectURL = `/${dropDownValue}/zoekresultaat`;
    if (postalCode.trim()) {
      redirectURL = `${redirectURL}?geolocation=${encodeURIComponent(postalCode)}`;
    }
    // Redirect the user to the constructed URL
    window.location.href = redirectURL;
  };

  useEffect(() => {
    if (props.options) {
      setDropDownValue(props.options[0]?.value);
    }
  }, []);

  return (
    <div className="font-roboto">
      {props?.searchTitle?.length && (
        <h1 className="font-bold text-sm leading-8 sm:leading-12 lg:leading-16 lg:leading-20 sm:mt-8 mb-2 lg:mb-4 text-white drop-shadow-md font-avantgarde lg:text-4xl">
          {props?.searchTitle}
        </h1>
      )}
      <div className="w-full sm:max-w-2xl lg:max-w-4xl rounded-lg p-5 sm:p-6 bg-white shadow-md">
        <form className="flex flex-col gap-4 sm:gap-0 items-center md:flex-row sm:justify-between">
          <div className="w-full flex flex-col sm:flex-row gap-4 sm:gap-0">
            <div className="w-full sm:w-1/2 sm:px-5">
              <label className="block text-sm lg:text-base font-bold text-blue-600" htmlFor="searchScope">
                Ik ben op zoek naar een
              </label>
              <SelectOption
                id="searchScope"
                options={props?.options ?? searchFilters}
                onSelect={handleSelectOfAf}
                addedInputStyle="py-0 h-11 sm:h-14 sm:border-none leading-none sm:px-0"
                addedStyle="w-full text-base !mt-0"
                initialSelectedValue={dropDownValue}
              />
            </div>

            <div className="w-full sm:w-1/2 sm:px-5 border-stone-50 sm:border-l-2">
              <label className="block text-sm lg:text-base font-bold text-blue-600" htmlFor="postalCode">
                In de buurt van
              </label>
              <input
                className="w-full sm:mt-0 h-11 sm:h-14 placeholder-stone-200 rounded p-4 lg:px-0 border border-stone-300 focus:outline-none focus:border-blue-500 sm:border-none bg-white"
                placeholder="Postcode of plaats"
                id="postalCode"
                value={postalCode}
                onChange={(e) => setPostalCode(e.target.value)}
              />
            </div>
          </div>

          <Button
            type="submit"
            variant="secondaryGradient"
            className="h-11 md:h-20 font-bold w-full md:w-36 sm:mt-4 md:mt-0"
            onClick={handleSearch}
          >
            <FontAwesomeIcon
              icon={faSearch as IconProp}
              className="text-base"
            />
            Zoeken
          </Button>
        </form>
      </div>
    </div>
  );
};

export default SearchBar;
